<template>
  <div class="comments-add-form">
    <div class="comment-add-form__avatar">
      <avatar class="user-avatar ms-text" size="small" icon="ios-person" />
    </div>
    <div class="comments-add-form__message">
      <i-input
        class="comments-add-form__textarea"
        v-model="message"
        @on-keydown.enter.ctrl="addComment"
        type="textarea"
        placeholder="Текст комментария"
      />
      <div class="comments-add-form__button">
        <i-button
          :disabled="!this.message"
          type="primary"
          @click="addComment"
          :loading="posting"
        >
          Добавить комментарий
        </i-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mainUrl } from '@/config/urls'

export default {
  props: ['id', 'type'],
  data () {
    return {
      message: '',
      posting: false,
      user: this.$store.state.auth.user,
      token: this.$store.state.auth.token,
      mainUrl
    }
  },
  methods: {
    getData () {
      return {
        text: this.message
      }
    },
    async addComment () {
      if (!this.message) return

      try {
        this.posting = true
        const url = `page/comment?object_id=${this.id}&object_type=${this.type}`
        const data = this.getData()
        await this.$store.dispatch('POST_REQUEST', { url, data })
        this.$emit('update')
        this.posting = false
        this.message = ''
      } catch (error) {
        console.log(error)
        this.posting = false
      }
    }
  }
}
</script>

<style lang="less">
.comments-add-form {
  padding: 16px;
  display: flex;

  &__message {
    margin-left: 8px;
  }

  &__textarea {
    width: 320px !important;
  }

  &__button {
    margin-top: 8px;
    text-align: right;
  }
}
</style>
